/**
 * Takes colors in hex format (i.e. #F06D06, with or without hash) and lightens or darkens them with a value.
 * like darken() or lighten() of the CSS preprocessors Sass
 * @param {*} color color to change
 * @param {*} amt value of change
 * @returns hex format
 */
export const lightenDarkenColor = (color, amt) => {
  
    var usePound = false;
  
    if (color[0] == "#") {
        color = color.slice(1);
        usePound = true;
    }
 
    var num = parseInt(color,16);
    
    // red
    let r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if  (r < 0) r = 0;

    // green
    let g = ((num >> 8) & 0x00FF) + amt;
    if (g > 255) g = 255;
    else if  (g < 0) g = 0;
 
    // blue
    let b = (num & 0x0000FF) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;

    return `${usePound?"#":""}${_fullColorHex(r, g, b)}`;
  
}

/**
 * Convert the color from hex to rgb format
 * @param {*} hex 
 * @returns value of rgb format
 */
export const hexToRgb = (hex) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`
        : "0, 0, 0";
}

/**
 * Private Convert one rgb color to hex format 
 * @param {*} rgb 
 * @returns 
 */
const _rgbToHex = (rgb) => { 
    let hex = Number(rgb).toString(16);
    if (hex.length < 2) hex = "0" + hex;
    return hex;
};

/**
 * Private Convert full rgb color to hex format 
 * @param {*} r 
 * @param {*} g 
 * @param {*} b 
 * @returns 
 */
const _fullColorHex = function(r,g,b) {   
    const red   = _rgbToHex(r);
    const green = _rgbToHex(g);
    const blue  = _rgbToHex(b);
    return red+green+blue;
  };